"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.toOperationExtraRaw = exports.fromOperationExtraRaw = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
function formatOperationSpecifics(op, unit) {
    var rewards = op.extra.rewards;
    return rewards
        ? " REWARDS : " +
            "".concat(unit
                ? (0, currencies_1.formatCurrencyUnit)(unit, new bignumber_js_1.BigNumber(rewards), {
                    showCode: true,
                    disableRounding: true
                }).padEnd(16)
                : rewards)
        : "";
}
function formatAccountSpecifics(account) {
    var algorandResources = account.algorandResources;
    (0, invariant_1["default"])(algorandResources, "algorand account expected");
    var unit = (0, account_1.getAccountUnit)(account);
    var formatConfig = {
        disableRounding: true,
        alwaysShowSign: false,
        showCode: true
    };
    var str = " ";
    str +=
        (0, currencies_1.formatCurrencyUnit)(unit, account.spendableBalance, formatConfig) +
            " spendable. ";
    if (algorandResources.rewards.gt(0)) {
        str +=
            (0, currencies_1.formatCurrencyUnit)(unit, algorandResources.rewards, formatConfig) + " rewards. ";
    }
    return str;
}
function fromOperationExtraRaw(extra) {
    if (extra && extra.rewards) {
        return __assign(__assign({}, extra), { rewards: new bignumber_js_1.BigNumber(extra.rewards) });
    }
    return extra;
}
exports.fromOperationExtraRaw = fromOperationExtraRaw;
function toOperationExtraRaw(extra) {
    if (extra && extra.rewards) {
        return __assign(__assign({}, extra), { rewards: extra.rewards.toString() });
    }
    return extra;
}
exports.toOperationExtraRaw = toOperationExtraRaw;
exports["default"] = {
    formatAccountSpecifics: formatAccountSpecifics,
    formatOperationSpecifics: formatOperationSpecifics,
    fromOperationExtraRaw: fromOperationExtraRaw,
    toOperationExtraRaw: toOperationExtraRaw
};
//# sourceMappingURL=account.js.map